import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@20.19.2_db0@0.3.2_eslint@8.57.1_ioredis@5_4c2acbb24c6b4677b2812a82dd18e3a0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@20.19.2_db0@0.3.2_eslint@8.57.1_ioredis@5_4c2acbb24c6b4677b2812a82dd18e3a0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}